export default __webpack_public_path__ + "static/media/photo--sm--misc-5.12c57066.jpg";